module.exports = __webpack_public_path__ + "static/media/ic_coronavirus_insurance_myway.7cbcba59.svg";